import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import FilterUniButtonModal from './FilterUniButtonModal'
import './FilterUniButton.scss'

class FilterUniButton extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      modalOpen: false
    }
  }

  render () {
    const uniButtonClass = classNames('FilterUniButton', {
      'FilterUniButton--active': !!this.props.currentlySelectedOption
    })

    let options = this.props.options
    let currentlySelectedOption
    let allOption

    if (this.props.includeAllOption) {
      allOption = {
        label: `All ${this.props.filterContext}`,
        filterValue: 'all'
      }
      options = [allOption].concat(options)

      currentlySelectedOption = this.props.currentlySelectedOption
        ? this.props.currentlySelectedOption
        : 'all'
    }

    return (
      <div className={uniButtonClass}>
        <div
          className='shown-filter'
          onClick={() => {
            this.setState({ modalOpen: true })
          }}
        >
          {this.props.currentlySelectedOption
            ? this.props.currentlySelectedOption
            : `All ${this.props.filterContext}`}
          <i className='fa fa-angle-down' />
        </div>
        <FilterUniButtonModal
          show={this.state.modalOpen}
          className='alo-mobile-modal'
          options={options}
          currentlySelectedOption={currentlySelectedOption}
          onSelect={option => {
            this.props.onSelect(option.filterValue || option.label)
          }}
          onHide={() => {
            this.setState({ modalOpen: false })
          }}
        />
      </div>
    )
  }
}

FilterUniButton.defaultProps = {
  includeAllOption: true
}

FilterUniButton.propTypes = {
  afterFilter: PropTypes.func,
  currentlySelectedOption: PropTypes.string,
  onSelect: PropTypes.func,
  filterContext: PropTypes.string,
  includeAllOption: PropTypes.bool,
  options: PropTypes.array
}

export default FilterUniButton
